/**
 * ExecutionStatusBadge — Reusable badge for automation/workflow execution status
 */

import { CheckCircle, XCircle, Loader2, Ban } from 'lucide-react';
import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';
import type { ExecutionStatus } from '@/lib/mock-automate-data';
import type { LucideIcon } from 'lucide-react';

const STATUS_CONFIG: Record<ExecutionStatus, { label: string; icon: LucideIcon; color: string }> = {
  completed: { label: 'Completed', icon: CheckCircle, color: 'bg-emerald-500/10 text-emerald-700 dark:text-emerald-300 border-emerald-500/20' },
  failed: { label: 'Failed', icon: XCircle, color: 'bg-red-500/10 text-red-700 dark:text-red-300 border-red-500/30' },
  running: { label: 'Running', icon: Loader2, color: 'bg-blue-500/10 text-blue-700 dark:text-blue-300 border-blue-500/30' },
  cancelled: { label: 'Cancelled', icon: Ban, color: 'bg-zinc-500/10 text-zinc-700 dark:text-zinc-300 border-zinc-500/30' },
};

export function ExecutionStatusBadge({ status, className }: { status: ExecutionStatus; className?: string }) {
  const config = STATUS_CONFIG[status];
  const Icon = config.icon;
  return (
    <Badge variant="outline" className={cn('text-[9px] gap-1', config.color, className)}>
      <Icon className={cn('h-2.5 w-2.5', status === 'running' && 'animate-spin')} />
      {config.label}
    </Badge>
  );
}
